// extracted by mini-css-extract-plugin
export default {"section":"PlanetsList_section__axUdy","planet-list":"PlanetsList_planet-list__0sU57"};